export { ContactService } from '../services/contact.service';

